import React, { Component } from 'react';
import {
  addMonths,
  subMonths,
  addDays,
  subDays,
  format,
  startOfWeek,
  addWeeks,
  subWeeks,
  isSameMonth,
  endOfWeek,
  startOfMonth,
  endOfMonth
} from 'date-fns';
import { browserHistory, Link } from 'react-router';
import PullToRefresh from 'react-simple-pull-to-refresh';
import moment from 'moment';
import _, { sortBy } from 'lodash';
import momentTz from 'moment-timezone';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withUser from '../../common/withUser';
import withGoBack from '../../common/withGoBack';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';
import withTableName from '../../common/withTableName';
import withSelectCaseDate from '../../common/withSelectCaseDate';
import withCaseFilter from '../../common/withCaseFilter';
import withOnline from '../../common/withOnline';
import withTeam from '../../common/withTeam';
import withCalendarFilter from '../../common/withCalendarFilter';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';
import withAggregatePlan from '../../common/withAggregatePlan';
import CaseRow from '../../components/CaseRow';
import CalenderSearchSection from '../../components/CalenderSearchSection';
import Calendar from '../../components/Calendar';
import Header from '../../components/Header';
import {
  getCasesByDate,
  getCases,
  bulkManageCaseAdd,
  getCasesByBetweenDate,
  deleteCaseByCaseId,
  updateCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
  getTableCaseByCaseId,
  syncCases,
  getCaseByCaseId,
  getVhnPpcValue,
  insertComplianceApp,
  bulkCaseUpdate,
  getHospitalByCustomerNo,
} from '../../utils/db';
import {
  addComplianceAppData,
  cancelCase,
  getShipments,
  listCases,
  listSingleCase,
  updateCase,
  updatePushToACM,
} from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import ZeroProductSubmitModal from '../../components/Models/ZeroProductSubmitModal';
import MrnOrPatientIdModal from '../../components/Models/MrnOrPatientIdModal';
import RequiredMrnOrPatientId from '../../components/Models/RequiredMrnOrPatientId';
import AlreadySubmittedCase from '../../components/Models/AlreadySubmittedCase';
import CancelCaseModal from '../../components/Models/CancelCaseModal';
import {
  getListCaseDate,
  getStoreLastVisitedRoute,
  getUser,
  // SERVER_TIMEZONE,
  sortData,
  storeLastVisitedRoute,
  storeListCaseDate
} from '../../common/globals';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import withVhnPpcOtherCharge from '../../common/withVhnPpcOtherCharge';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
import withUpdatedRoute from '../../common/withUpdatedRoute';
import withCaseDer from '../../common/withCaseDer';
import withViewDersDetails from '../../common/withViewDersDetails';
// import DgrRequiredOnSubmitCase from '../../components/Models/DgrRequiredOnSubmitCase';
import FilterIcon from '../../assets/images/filter-outline.png';
import ZeroSelected from '../../assets/images/zero_selectd.png';
import ZeroOutLine from '../../assets/images/zero.png';
import ArrowCollapse from '../../assets/images/arrow-collapse-vertical.png';
import ArrowExpand from '../../assets/images/arrow-expand-vertical.png';
import CalenderIcon from '../../assets/images/calendar-outline.png';
import ClockTimeIcon from '../../assets/images/clock-time-three-outline.png';
import HospitalBoxIcon from '../../assets/images/hospital-box-outline.png';
import CartOutlineIcon from '../../assets/images/cart-outline.png';
import TruckOutlineIcon from '../../assets/images/Truck-new.png';
import WeekCalendar from '../../components/WeekCalendar';
import DgrRequiredOnSubmitCase from '../../components/Models/DgrRequiredOnSubmitCase.js';
import withPrevRoute from '../../common/withPrevRoute.js';
import withSalesYTD from '../../common/withSalesYTD.js';
import AcmPushCaseConfirmModal from '../../components/Models/AcmPushCaseConfirmModal';
import AcmPushCaseStatusModal from '../../components/Models/AcmPushCaseStatusModal';
import CustCaseIDModal from '../../components/Models/CustCaseIDModal';
import withCalendarMonthEndDate from '../../common/withCalendarMonthEndDate';
import RequiredCustCaseID from '../../components/Models/RequiredCustCaseID';

class ManageCases extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMonth: new Date(),
      currentWeek: new Date(),
      selectedDate: new Date(),
      dateLogs: [],
      hideShowCalendar: true,
      smallLargeCard: false,
      isAcm: false,
      filterData: {},
      isProduct: false,
      casesList: [],
      hospitalGroupCasesList: [],
      casesDetail: [],
      mrnPatientIdCaseId: null,
      caseDetail: {},
      mrnOrPatientCaseId: '',
      cancelId: 0,
      acmCases: {},
      screenWidth: '',
      isGroup: false,
      isHideTeamName: false,
      screenHeight: '',
      shipments: [],
      idForDgrRequest: null,
      filterDataNew: {},
      acmPushCaseStatusCount: 0,
      acmMessageStatusFlag: [],
      acmMessageStatusMessage: '',
      hospitalUseCustCaseIDStatus: false,
    };
    this.zeroProductSubmitModal = null;
    this.mrnOrPatientModal = null;
    this.requiredmrnOrPatientModal = null;
    this.alreadySubmittedCase = null;
    this.cancelCaseModal = null;
    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    this.dgrRequiredOnSubmitCaseModal = null;
    this.acmPushCaseStatusModal = null;
    this.acmPushCaseConfirmModal = null;
    this.custCaseIDModal = null;
    this.requiredCustCaseIDModal = null;

    // Ref to the bottom of the list
    this.topRef = React.createRef();
  }

  componentDidMount() {
    try {
      const { setSetsListStateStorage, setGoBack, setSelectedSetsPayload } = this.props;
      setSetsListStateStorage({});
      setSelectedSetsPayload([]);
      setGoBack([]);
      this.zeroProductSubmitModal = new window.bootstrap.Modal(window.$('#zeroProductSubmitModal'));
      this.mrnOrPatientModal = new window.bootstrap.Modal(window.$('#mrnOrPatientIdModal'));
      this.requiredmrnOrPatientModal = new window.bootstrap.Modal(window.$('#requiredMrnOrPatientId'));
      this.alreadySubmittedCase = new window.bootstrap.Modal(window.$('#alreadySubmittedCase'));
      this.cancelCaseModal = new window.bootstrap.Modal(window.$('#cancelCaseModal'));
      this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
      this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
      this.dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$('#dgrRequiredOnSubmitCaseModal'));
      this.acmPushCaseStatusModal = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      this.acmPushCaseConfirmModal = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      this.custCaseModal = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      this.requiredCustCaseIDModal = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));

      // window.addEventListener('scroll', this._onCasesScroll);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this._onCasesScroll);
  }

  _onCasesScroll = () => {
    window.closeAllCasesMenu();
  }

  _getScreenWidth = () => {
    this.setState({ screenWidth: window.screen.width, screenHeight: window.screen.height });
  }

  _updateCaseList = (caseList, detailUpdate = true) => {
    try {
      const { setAggregatePlan } = this.props;
      const { shipments } = this.state;
      const response = sortBy(caseList, ['CaseTime', 'CustomerName', 'SurgeonName', 'PatientID']);
      const casesListGroups = _.chain(response)
        .orderBy(['CaseTime'], ['asc'])
        .groupBy('CustomerName')
        .map((value, key) => {
          // Filter the Case Sets Qty
          const caseSets = value.filter((c) => c.case_sets.length > 0).map((set) => {
            let setsQty = 0;
            setsQty = set.case_sets.reduce((sum, { Quantity }) => sum + parseInt(Quantity, 10), 0);
            return ({ qty: setsQty });
          });
          const totalQty = _.sumBy(caseSets, 'qty');
          const caseId = value[0].id;
          return (
            {
              customer: key, data: value, qty: totalQty, id: caseId
            }
          );
        })
        .value();
      const filteredTotalSeta = casesListGroups.filter((obj) => obj.customer !== 'null');
      setAggregatePlan(sortData(filteredTotalSeta, 'customer'));
      const sortedCaseGroup = this.sortCaseGroupData(casesListGroups).map((item) => {
        const ownShipments = shipments.filter((shipment) => shipment.ShipToLoc === item.customer);
        if (!ownShipments.length) {
          return {
            ...item,
            hasShipments: !!ownShipments.length
          };
        }
        const shipFromLoc = ownShipments
          .some((shipment) => shipment.ShipFromLoc === 'DEPUY') && shipments.some((shipment) => shipment.ShipFromLoc === 'OFFICE')
          ? 'ALL' : ownShipments.some((shipment) => shipment.ShipFromLoc === 'DEPUY')
            ? 'DEPUY' : 'OFFICE';
        return {
          ...item,
          shipFromLoc,
          hasShipments: !!ownShipments.length
        };
      });
      if (detailUpdate) {
        this.setState({
          casesList: response,
          hospitalGroupCasesList: sortedCaseGroup,
          casesDetail: response,
        });
      } else {
        this.setState({
          casesList: response,
          hospitalGroupCasesList: sortedCaseGroup,
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  sortCaseGroupData = (data) => {
    const sortedCaseData = _.sortBy(data,
      [function (item) { return item.customer; }]);
    const filteredNullCaseData = sortedCaseData.filter((item) => item.customer === 'null');
    const filteredCaseData = sortedCaseData.filter((item) => item.customer !== 'null');
    for (const caseData of filteredNullCaseData) {
      filteredCaseData.unshift(caseData);
    }
    return filteredCaseData;
  }

  onDateClick = async (date, value = null) => {
    try {
      const { setSelectCaseDate, selectCaseDate, online } = this.props;
      const { currentMonth } = this.state;
      const sameMonth = isSameMonth(currentMonth, date);
      // If user want to remove filterData please uncomment below block code
      // const { setSelectCaseDate, selectCaseDate, setCaseFilter } = this.props;
      // const clickDate = moment(date).format('YYYY-MM-DD');
      // const selectedDate = moment(selectCaseDate).format('YYYY-MM-DD');
      // const dateIsSame = moment(clickDate).isSame(moment(selectedDate));
      // if (!dateIsSame) {
      //   this.setState({
      //     filterData: {}
      //   });
      //   setCaseFilter({});
      // }
      if (value === 'add') {
        const day = moment(new Date()).format('D');
        const month = moment(currentMonth).format('M');
        const year = moment(currentMonth).format('yyyy');
        const currentDateWithMonth = moment().year(year).month(month).date(day);
        const removeMonth = moment(subMonths(moment(currentDateWithMonth)._d, 1));
        this.setState({
          selectedDate: moment(date)._d,
          currentWeek: isSameMonth(selectCaseDate, moment(removeMonth)._d)
            ? moment(selectCaseDate)._d
            : moment(removeMonth)._d
        });
      } else {
        this.setState({
          selectedDate: moment(date)._d,
          currentMonth: date,
          currentWeek: moment(date)._d
        });
      }
      if (online) {
        if (!sameMonth) {
          await this._getListCases(moment(date).startOf('month').format('YYYY-MM-DD'),
            moment(date).endOf('month').format('YYYY-MM-DD'));
        } else {
          await this._getListCases(moment(date).format('YYYY-MM-DD'),
            moment(date).format('YYYY-MM-DD'));
        }
      }
      setSelectCaseDate(moment(date)._d);
      const getByCaseId = await getCasesByBetweenDate(moment(date).format('YYYY-MM-DD'),
        moment(date).format('YYYY-MM-DD'));
      this._updateCaseList(getByCaseId);
      this.onFilter();
      await this._getDateSlot();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _getListCases = async (startDate, endDate) => {
    try {
      // console.log(this.props);
      const {
        online, setLoader, selectCaseDate, caseFilter, setSalesYTD, setCalendarMonthEndDate
      } = this.props;
      setLoader(true);
      await storeListCaseDate(moment(startDate)._d);
      if (online) {
        // await deleteSyncedCases();
        await syncCases();
        await listCases(
          { date_start: moment(startDate).format('YYYY-MM-DD'), date_end: moment(endDate).format('YYYY-MM-DD') }
        ).then(async (response) => {
          const { data, ytd, month_end } = response;
          setSalesYTD(ytd);
          if (data !== undefined) {
            await bulkCaseUpdate(data, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'));
            const caseResResult = await getCases();
            const result = data.filter(
              (o1) => !caseResResult.some((o2) => o1.RepCaseNo === o2.RepCaseNo)
            );
            result.map((item, key) => {
              result[key].Sync = 0;
            });
            if (Object.keys(result).length > 0) {
              await bulkManageCaseAdd(result);
            }
          }
          setCalendarMonthEndDate(month_end);
        }).finally(() => setLoader(false));
      } else {
        await getCasesByBetweenDate(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')).then((res) => {
          if (Object.keys(caseFilter).length > 0) {
            this.setState({ casesDetail: res }, () => {
              this._onFilter(caseFilter);
            });
          } else {
            this._updateCaseList(res);
          }
        });
      }
      await getCasesByDate(moment((selectCaseDate === '' ? new Date() : selectCaseDate)).format('YYYY-MM-DD')).then((response) => {
        if (Object.keys(caseFilter).length > 0) {
          this.setState({ casesDetail: response }, () => {
            this._onFilter(caseFilter);
          });
        } else {
          this._updateCaseList(response);
        }
        setLoader(false);
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoForward = () => {
    try {
      const { setSelectCaseDate } = this.props;
      const { selectedDate } = this.state;
      setSelectCaseDate(selectedDate);
      storeLastVisitedRoute('add-case');
      this._onGoBack();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      const { filterData } = this.state;
      _.mapKeys(data, (value) => {
        if (_.isArray(value)) {
          _.mapKeys(value, (item) => {
            item.filter((e) => typeof e === 'string' && e !== '');
          });
        }
      });
      _.mapKeys(data, (value, key) => {
        if (_.isArray(value) && _.isEmpty(value)) delete data[key];
      });
      const { notify, setCaseFilter } = this.props;
      for (const value in data) {
        if (data[value] === null || data[value] === undefined || data[value] === '' || data[value] === 'NONE') {
          notify({ type: 'warning', message: 'No data to filter', time: 3 });
          delete data[value];
        } else {
          const key = Object.keys(data)[0];
          if (!filterData.hasOwnProperty(key)) {
            filterData[key] = [];
          }
          if (!filterData[key].includes(data[key])) {
            filterData[key] = [...filterData[key], data[key]];
          }

          setCaseFilter(filterData);
          this.setState({
            filterData
          }, () => {
            this.onFilter();
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  onFilter = () => {
    try {
      const {
        filterData, isAcm, casesDetail, isProduct, hideShowCalendar, smallLargeCard
      } = this.state;
      const { setCalendarFilter } = this.props;
      setCalendarFilter({
        isAcm, isProduct, hideShowCalendar, smallLargeCard
      });
      let data = [...casesDetail];
      if (filterData.hasOwnProperty('selectSurgeon')) {
        data = (data.filter((item) => filterData.selectSurgeon.includes(item.SurgeonName)));
      }
      if (filterData.hasOwnProperty('selectHospitals')) {
        data = (data.filter((item) => filterData.selectHospitals.includes(item.CustomerName)));
      }
      if (filterData.hasOwnProperty('selectedRefs')) {
        data = (data.filter((item) => filterData.selectedRefs.includes(item.CoverRep)));
      }
      if (filterData.hasOwnProperty('ProcedureType')) {
        data = (data.filter((item) => filterData.ProcedureType.includes(item.ProcedureType)));
      }
      if (filterData.hasOwnProperty('selectedTypes')) {
        data = (data.filter((item) => filterData.selectedTypes.includes(item.AltCaseType)));
      }
      if (filterData.hasOwnProperty('Side')) {
        data = (data.filter((item) => filterData.Side.includes(item.Side)));
      }
      if (filterData.hasOwnProperty('PatientID')) {
        data = (data.filter((item) => filterData.PatientID.includes(item.PatientID)));
      }
      if (filterData.hasOwnProperty('selectedAcm')) {
        data = (data.filter((item) => item.ACMCaseID !== null));
      }

      if (filterData.hasOwnProperty('selectSubmitted')) {
        if (filterData.selectSubmitted.length <= 1) {
          const updatedSubmitted = filterData.selectSubmitted.map((item) => (item === 'SUBMITTED' ? '1' : '0'));

          // Determine ProductSubmitted filter values
          const productFilterValues = updatedSubmitted[0] === '1' ? ['1', null] : ['0'];

          // Filter data based on Submitted
          data = data.filter((item) => {
            if (updatedSubmitted[0] === '1' && item.Submitted === '1') {
              for (const key in productFilterValues) {
                if (productFilterValues[key] === item.ProductSubmitted) {
                  return true;
                }
              }
            }

            if (updatedSubmitted[0] === '0') {
              for (const key in productFilterValues) {
                if (item.ProductSubmitted === null && item.Submitted === updatedSubmitted[0]) {
                  return true;
                }

                if (item.ProductSubmitted === productFilterValues[key]) {
                  return true;
                }

                if (item.ProductSubmitted === '1' && item.Submitted === updatedSubmitted[0]) {
                  return true;
                }
              }
            }
          });
        }
      }

      if (filterData.hasOwnProperty('MRN')) {
        data = (data.filter((item) => filterData.MRN.includes(item.MRN)));
      }

      // if (isAcm) {
      //   data = (data.filter((item) => item.ACMCaseID !== null));
      // }

      if (isProduct) {
        data = (
          data.filter(
            (item) => (
              item.case_dgrs.length === 0 && item.case_products.length === 0
            )
          )
        );
      }

      const searchFilter = this.topRef.current;
      if (searchFilter) {
        window.scrollTo(0, searchFilter.offsetTop);
      }

      this._updateCaseList(data, false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path) => {
    try {
      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveFilter = (key) => {
    const { filterData } = this.state;
    if (filterData.hasOwnProperty(key)) {
      delete filterData[key];
    }
    this.setState({ filterData }, () => {
      this.onFilter();
    });
  }

  _addDays = async () => {
    try {
      const { setSelectCaseDate } = this.props;
      // If user want to remove filterData please uncomment below block code
      // const { setSelectCaseDate, selectCaseDate, setCaseFilter } = this.props;
      this.setState({
        selectedDate: addDays(this.state.selectedDate, 1),
      }, () => {
        // const clickDate = moment(this.state.selectedDate).format('YYYY-MM-DD');
        // const selectedDate = moment(selectCaseDate).format('YYYY-MM-DD');
        // const dateIsSame = moment(clickDate).isSame(moment(selectedDate));
        // if (!dateIsSame) {
        //  this.setState({
        //   filterData: {}
        // });
        //  setCaseFilter({});
        //  }
        setSelectCaseDate(this.state.selectedDate);
      });
      const addSelectedDays = moment(addDays(this.state.selectedDate, 1)).format('YYYY-MM-DD');
      const getByAddDaysCaseRes = await getCasesByDate(moment(addSelectedDays).format('YYYY-MM-DD'));
      this._updateCaseList(getByAddDaysCaseRes);
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _subDays = async () => {
    try {
      const { setSelectCaseDate } = this.props;
      // If user want to remove filterData please uncomment below block code
      // const { setSelectCaseDate, selectCaseDate, setCaseFilter } = this.props;
      this.setState({
        selectedDate: subDays(this.state.selectedDate, 1),
      }, () => {
        // const clickDate = moment(this.state.selectedDate).format('YYYY-MM-DD');
        // const selectedDate = moment(selectCaseDate).format('YYYY-MM-DD');
        // const dateIsSame = moment(clickDate).isSame(moment(selectedDate));
        // if (!dateIsSame) {
        //   this.setState({
        //     filterData: {}
        //   });
        //   setCaseFilter({});
        // }
        setSelectCaseDate(this.state.selectedDate);
      });
      const subSelectedDays = moment(subDays(this.state.selectedDate, 1)).format('YYYY-MM-DD');
      const getBySubDaysCaseRes = await getCasesByDate(moment(subSelectedDays).format('YYYY-MM-DD'));
      this._updateCaseList(getBySubDaysCaseRes);
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _addWeeks = async () => {
    try {
      // const { selectCaseDate } = this.props;
      this.setState({
        currentWeek: addWeeks(this.state.currentWeek, 1),
      }, async () => {
        const endDate = endOfWeek(this.state.currentWeek);
        const getListCase = await getListCaseDate();
        if (!isSameMonth(endDate, moment(getListCase)._d)) {
          const monthStart = startOfMonth(endDate);
          const monthEnd = endOfMonth(endDate);
          await this._getListCases(monthStart, monthEnd);
          await this._getDateSlot();
          this.setState({
            currentMonth: endDate,
          });
        }
      });
      await this._getDateSlot();
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _subWeeks = async () => {
    try {
      // const { selectCaseDate } = this.props;
      this.setState({
        currentWeek: subWeeks(this.state.currentWeek, 1),
      }, async () => {
        const startDate = startOfWeek(this.state.currentWeek);
        const getListCase = await getListCaseDate();
        if (!isSameMonth(startDate, moment(getListCase)._d)) {
          const monthStart = startOfMonth(startDate);
          const monthEnd = endOfMonth(startDate);
          await this._getListCases(monthStart, monthEnd);
          await this._getDateSlot();
          this.setState({
            currentMonth: startDate,
          });
        }
      });
      await this._getDateSlot();
      // this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _addMonths = async () => {
    try {
      // const { selectCaseDate } = this.props;
      this.setState({
        currentMonth: addMonths(this.state.currentMonth, 1),
        // selectedDate: moment(addMonths(this.state.currentMonth, 1))._i,
      });
      const monthStartDate = moment(addMonths(this.state.currentMonth, 1)).startOf('month').format('YYYY-MM-DD');
      const monthEndDate = moment(addMonths(this.state.currentMonth, 1)).endOf('month').format('YYYY-MM-DD');
      await this._getListCases(monthStartDate, monthEndDate);
      await this._getDateSlot();
      // this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate, 'add');
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _subMonths = async () => {
    try {
      // const { selectCaseDate } = this.props;
      this.setState({
        currentMonth: subMonths(this.state.currentMonth, 1),
        // selectedDate: moment(subMonths(this.state.currentMonth, 1))._i,
      });
      const monthStartDate = moment(subMonths(this.state.currentMonth, 1)).startOf('month').format('YYYY-MM-DD');
      const monthEndDate = moment(subMonths(this.state.currentMonth, 1)).endOf('month').format('YYYY-MM-DD');
      await this._getListCases(monthStartDate, monthEndDate);
      await this._getDateSlot();
      // this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate, 'add');
      this.onFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  productCaseFilter = (cases) => {
    try {
      const { isProduct } = this.state;
      cases.map((item) => {
        if (isProduct) {
          return (item.case_dgrs.length === 0 && item.case_products.length === 0);
        }
        return cases;
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProduct = () => {
    try {
      const { isProduct } = this.state;
      this.setState({ isProduct: !isProduct }, () => {
        this.onFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSmallLargeCard = () => {
    try {
      const { smallLargeCard } = this.state;
      this.setState({ smallLargeCard: !smallLargeCard }, () => {
        this.onFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onHideShowCalendar = () => {
    try {
      const {
        hideShowCalendar
      } = this.state;
      if (hideShowCalendar === false) {
        this.setState({
          hideShowCalendar: true,
          // isHideTeamName: false
        }, () => {
          this.onFilter();
        });
      } else {
        this.setState({
          hideShowCalendar: false,
          // isHideTeamName: true
        }, () => {
          this.onFilter();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getDateSlot = async () => {
    try {
      const caseRes = await getCases();
      const caseDateObj = {};
      const dateLogsValue = [];
      caseRes.map((val) => {
        if (!caseDateObj.hasOwnProperty(val.CaseDate)) {
          caseDateObj[val.CaseDate] = [];
        }
        caseDateObj[val.CaseDate] = [...caseDateObj[val.CaseDate], val];
      });

      Object.keys(caseDateObj).map((value) => {
        const { length } = caseDateObj[value];
        const submitted = [];
        const productSubmitted = [];
        caseDateObj[value].map((item) => {
          submitted.push(item.Submitted);
          productSubmitted.push(item.ProductSubmitted);
          if (!caseDateObj.hasOwnProperty(item.CaseDate)) {
            caseDateObj[item.CaseDate] = [];
          }
          caseDateObj[item.CaseDate] = {
            count: length,
            border: submitted.includes('0') || productSubmitted.includes('0') ? 'red' : 'yellow'
          };
        });
      });
      dateLogsValue.push(caseDateObj);
      this.setState({ dateLogs: dateLogsValue });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  acmCaseFilter = (cases) => {
    try {
      const { isAcm } = this.state;
      if (isAcm) {
        return (cases.filter((item) => item.ACMCaseID !== null));
      }
      return cases;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* _onACM = () => {
    try {
      const { isAcm } = this.state;
      this.setState({ isAcm: !isAcm }, () => {
        this.onFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  } */

  _onToday = async () => {
    try {
      const { setSelectCaseDate } = this.props;
      // If user want to remove filterData please uncomment below block code
      // const { setCaseFilter, setSelectCaseDate } = this.props;
      // const clickDate = moment(new Date()).format('YYYY-MM-DD');
      // const selectedDate = moment(new Date()).format('YYYY-MM-DD');
      // const dateIsSame = moment(clickDate).isSame(moment(selectedDate));
      // if (dateIsSame) {
      //   this.setState({
      //     filterData: {}
      //   });
      //   setCaseFilter({});
      // }
      this.setState({
        selectedDate: new Date(),
        currentMonth: new Date()
      });
      setSelectCaseDate(new Date());
      this.onDateClick(new Date());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseCancel = async () => {
    try {
      const {
        notify, setLoader, online, tableName, selectCaseDate
      } = this.props;
      const { cancelId } = this.state;
      const caseRes = await getTableCaseByCaseId(cancelId, tableName);

      if (online && caseRes && caseRes.CaseScheduleID !== null) {
        const cancelCaseRes = await cancelCase(caseRes.CaseScheduleID);
        const { message, status } = cancelCaseRes;
        if (status) {
          setLoader(true);
          // notify({ type: 'success', message });
          if (message === 'You can not delete this case') {

          } else {
            await deleteCaseByCaseId(caseRes.id);
          }
          const getMonthAndYear = moment(caseRes.CaseDate).format('MM-YY');
          const passMonthAndYear = moment(getMonthAndYear, 'MM-YY');
          await this._getListCases(passMonthAndYear.startOf('month').format('YYYY-MM-DD'),
            passMonthAndYear.endOf('month').format('YYYY-MM-DD'));
          await this._getDateSlot();
          this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
          this.onFilter();
          // browserHistory.push('/manage-cases');
        } else {
          notify({ type: 'error', message });
        }
        setLoader(false);
      } else {
        setLoader(true);
        notify({ type: 'warning', message: 'Case must be submitted and have a CaseNo before cancel case.' });
        // await deleteCaseByCaseId(caseRes.id);
        const getMonthAndYear = moment(caseRes.CaseDate).format('MM-YY');
        const passMonthAndYear = moment(getMonthAndYear, 'MM-YY');
        await this._getListCases(passMonthAndYear.startOf('month').format('YYYY-MM-DD'),
          passMonthAndYear.endOf('month').format('YYYY-MM-DD'));
        await this._getDateSlot();
        this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
        this.onFilter();
        // browserHistory.push('/manage-cases');
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancel = async (id) => {
    try {
      this.setState({ cancelId: id });
      this.cancelCaseModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelCaseBack = () => {
    try {
      this.cancelCaseModal.hide();
      this.setState({ acmCases: {} });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGetACMCase = async (id) => {
    try {
      const acmCase = await getCaseByCaseId(id);
      if (acmCase.ACMCaseID !== null) {
        return this.setState({ acmCases: acmCase });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseNo = () => {
    try {
      this.zeroProductSubmitModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitProductCaseYes = async () => {
    try {
      const {
        notify, setLoader, tableName, selectCaseDate, user: { name }, team: { dgrRequired },
      } = this.props;
      const { caseDetail } = this.state;
      let responseJson = {};
      const {
        CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
        PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
        ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
        MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
        case_products, ...partialObject
      } = caseDetail;
      const subset = {
        CaseScheduleID,
        CaseDate,
        CaseTime,
        CustomerNo,
        CustomerName,
        SurgeonName,
        PatientID,
        ProcedureType,
        CaseType,
        Side,
        Comments,
        RepNotes,
        ProductNotes,
        ProductSubmitted,
        RepPONumber,
        Submitted,
        CoverRep,
        ChangeRep: name,
        DGRUpload,
        MRN,
        Gender,
        Age,
        ACMPlannedParts,
        ACMSelectedParts,
        Height,
        Weight,
        selectedSets
      };

      subset.Submitted = '1';
      if (subset.ProductSubmitted === '0') {
        subset.ProductSubmitted = '1';
      } else {
        if (caseDetail.case_products.length > 0) {
          subset.ProductSubmitted = '1';
        }
      }
      if (caseDetail.case_products.length > 0 && dgrRequired > 0) {
        if (caseDetail.case_dgrs.length === 0) {
          subset.DGRUpload = '1';
        }
      } else if (caseDetail.case_dgrs.length > 0) {
        subset.DGRUpload = '2';
      }
      if (typeof caseDetail.case_products !== 'undefined' && caseDetail.case_products.length > 0) {
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null || subset.ProductNotes === 'No products used') ? '' : subset.ProductNotes;
      } else {
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null) ? '' : subset.ProductNotes;
      }
      await this._getListCases(caseDetail.CaseDate, caseDetail.CaseDate);
      await this._getDateSlot();
      const newArrayOfObj = partialObject.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      subset.selectedSets = newArrayOfObj;
      setLoader(true);
      await updateCase(subset);
      setLoader(false);
      responseJson = await listSingleCase(caseDetail.CaseScheduleID);
      const { message, status } = responseJson;
      if (status) {
        const caseDetails = responseJson.data[0];
        caseDetails.id = parseInt(caseDetail.id, 10);
        caseDetails.CaseDate = caseDetail.CaseDate;
        caseDetails.CaseTime = caseDetail.CaseTime;
        // Update the response when update API change
        updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
        const getMonthAndYear = moment(caseDetails.CaseDate).format('MM-YY');
        const passMonthAndYear = moment(getMonthAndYear, 'MM-YY');
        await this._getListCases(passMonthAndYear.startOf('month').format('YYYY-MM-DD'),
          passMonthAndYear.endOf('month').format('YYYY-MM-DD'));
        await this._getDateSlot();
        this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
        this.onFilter();
        // updateCaseByPrimaryId(caseDetail.id, caseDetail);
        this.zeroProductSubmitModal.hide();
      } else {
        notify({ type: 'error', message });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitCase = async (id) => {
    try {
      const {
        notify, online, setLoader, tableName, selectCaseDate,
        user: { name }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      this.setState({
        caseDetail
      });

      if (online) {
        // if ((caseDetail.case_products.length > 0 || caseDetail.case_dgrs.length === 0)
        // && caseDetail.ProductSubmitted === '0' &&
        //     dgrRequired === 6 && caseDetail.case_dgrs.length === 0) {
        //   // notify({
        //   //   type: 'error',
        //   //   message: 'A DGR must be uploaded for this case before it can be submitted.'
        //   // });
        //   // this.dgrRequiredModal.show();
        //   this.dgrRequiredOnSubmitCaseModal.show();
        //   return;
        // }
        if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
          this.zeroProductSubmitModal.show();
        } else {
          let responseJson = {};
          const {
            CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
            PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
            ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
            MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
            case_dgrs, case_products,
            ...partialObject
          } = caseDetail;
          const subset = {
            CaseScheduleID,
            CaseDate,
            CaseTime,
            CustomerNo,
            CustomerName,
            SurgeonName,
            PatientID,
            ProcedureType,
            CaseType,
            Side,
            Comments,
            RepNotes,
            ProductNotes,
            ProductSubmitted,
            RepPONumber,
            Submitted,
            CoverRep,
            ChangeRep: name,
            DGRUpload,
            MRN,
            Gender,
            Age,
            ACMPlannedParts,
            ACMSelectedParts,
            Height,
            Weight,
            selectedSets
          };

          const newArrayOfObj = partialObject.case_sets.map(({
            CasePlanId: CasePlanID,
            ...rest
          }) => ({
            CasePlanID,
            ...rest
          }));
          subset.selectedSets = newArrayOfObj;

          if (caseDetail.case_products.length === 0 && caseDetail.case_dgrs.length === 0 && caseDetail.Submitted === '0') {
            subset.DGRUpload = '0';
          }

          subset.Submitted = '1';
          subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length > 0) && (subset.ProductSubmitted === '0')) ? '1'
            : ((case_dgrs.length > 0 || case_products.length === 0) && (subset.ProductSubmitted === '1')) ? '1' : null);
          // subset.ProductSubmitted = (((case_dgrs.length > 0 || case_products.length >= 0)
          // && (subset.ProductSubmitted === '0')) ? '1' : null);
          if (subset.ProductSubmitted === '0') {
            subset.ProductSubmitted = '1';
          } else {
            if (caseDetail.case_products.length > 0) {
              subset.ProductSubmitted = '1';
            }
          }

          setLoader(true);
          await updateCase(subset);
          responseJson = await listSingleCase(caseDetail.CaseScheduleID);
          const { message, status } = responseJson;
          if (status) {
            const caseDetails = responseJson.data[0];
            caseDetails.id = parseInt(caseDetail.id, 10);
            caseDetails.CaseDate = caseDetail.CaseDate;
            caseDetails.CaseTime = caseDetail.CaseTime;
            // Update the response when update API change
            updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
            const getMonthAndYear = moment(caseDetails.CaseDate).format('MM-YY');
            const passMonthAndYear = moment(getMonthAndYear, 'MM-YY');
            await this._getListCases(passMonthAndYear.startOf('month').format('YYYY-MM-DD'),
              passMonthAndYear.endOf('month').format('YYYY-MM-DD'));
            await this._getDateSlot();
            this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
            this.onFilter();
          } else {
            notify({ type: 'error', message });
          }
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenMrnPatientIdModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });
        }
      }

      this.setState({
        mrnOrPatientCaseId: id
      });

      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenCustomerCaseModal = async (id) => {
    try {
      const {
        tableName
      } = this.props;

      this.setState({
        mrnOrPatientCaseId: id
      });

      const caseRes = await getTableCaseByCaseId(id, tableName);

      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);

        if (
          hosptalRes.UseCustCaseID === '1'
          && caseRes.CustCaseID === null
          && (caseRes.ProductSubmitted === null || caseRes.ProductSubmitted !== '1')
        ) {
          this.setState({
            hospitalUseCustCaseIDStatus: true
          });

          this._onCustomerCaseIDStatus();
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#custCaseIDModal'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextCustomerCaseIDStatus = () => {
    try {
      const custCaseIDStatus = new window.bootstrap.Modal(window.$('#requiredCustCaseID'));
      custCaseIDStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onNextAddPatientIdOrMrn = () => {
    try {
      this.requiredmrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddPatientIdOrMrn = () => {
    try {
      this.mrnOrPatientModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseSubmitted = () => {
    try {
      this.alreadySubmittedCase.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVhnPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vhnPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        browserHistory.push(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        browserHistory.push(`/manage-case/${id}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }

    // try {
    //   const { tableName } = this.props;
    //   const { mrnOrPatientCaseId } = this.state;
    //   let caseDetail = {};
    //   if (id === undefined) {
    //     caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
    //   } else {
    //     caseDetail = await getTableCaseByCaseId(id, tableName);
    //     this.setState({ mrnOrPatientCaseId: id });
    //   }
    //   if (caseDetail.case_products.length > 0) {
    //     const vhnProductNo = caseDetail.case_products.find((e) => e.ProductNo === '099995000');
    //     if (_.isEmpty(vhnProductNo)) {
    //       this.vhnPpcModal.show();
    //     } else {
    //       browserHistory.push(`/manage-case/${id}/products/list`);
    //     }
    //   } else {
    //     this.vhnPpcModal.show();
    //   }
    // } catch (e) {
    //   Bugsnag.notify(e);
    // }
  }

  _onClickVhnPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      let vhnPpcValue = {};
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VHN-PPC') {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VHN-PPC') {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          this._onGoBack();
          browserHistory.push(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'No';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'NO';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddVrasPpc = async (id) => {
    try {
      const { tableName, setLoader } = this.props;
      const { mrnOrPatientCaseId } = this.state;
      let caseDetail = {};
      if (id === undefined) {
        caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      } else {
        caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ mrnOrPatientCaseId: id });
      }
      if (caseDetail.VelysUsed === null) {
        this.vrasPpcModal.show();
        setLoader(false);
      } else if (caseDetail.case_products.length > 0) {
        this._onRedirect(`/manage-case/${id}/products/list`);
        setLoader(false);
      } else {
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYes = async () => {
    try {
      const {
        tableName, setVhnPpcOtherCharge, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vrasPpcValue = vhnPpc;
        }
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      setVhnPpcOtherCharge(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              if (complainAppData.ComplianceType === 'VRAS-PPC') {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
              } else {
                this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
              }
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'YES';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        if (complainAppData.ComplianceType === 'VRAS-PPC') {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add/other-charge`);
        } else {
          this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        }
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNo = async () => {
    try {
      const {
        tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vrasPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vrasPpcValue = vhnPpc;
        }
      }

      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vrasPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: momentTz(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: momentTz(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? '0' : '1'
      };
      setLoader(true);
      if (online) {
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
              this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
            }
          });
      } else {
        await insertComplianceApp(complainAppData);
        caseDetail.Submitted = '0';
        caseDetail.Synced = '0';
        caseDetail.VelysUsed = 'NO';
        caseDetail.Sync = 1;
        updateTableWiseCaseByCaseId(caseDetail.id, caseDetail, tableName);
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMrnPatientIdAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId, hospitalUseCustCaseIDStatus } = this.state;
      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextAddPatientIdOrMrn();
        return;
      }

      if (formData.hasOwnProperty('patientId')) {
        caseDetail.PatientID = (formData.patientId !== null || formData.patientId !== undefined)
          ? formData.patientId
          : null;
      }

      if (formData.hasOwnProperty('mrn')) {
        caseDetail.MRN = (formData.mrn !== null || formData.mrn !== undefined)
          ? formData.mrn
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets
        };
        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        subset.selectedSets = newArrayOfObj;
        // subset.selectedSets = caseDetail.case_sets;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            if (Object.keys(formData).length > 0) {
              // notify({ type: 'success', message });
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVhnPpc();
                }
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onAddVrasPpc();
                }
              } else if (caseDetail.case_products.length > 0) {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
                }
              } else {
                if (hospitalUseCustCaseIDStatus) {
                  this._onOpenCustomerCaseModal(caseDetail.id);
                } else {
                  this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
                }
              }
            }

            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            // setLoader(false);
            this.setState({ caseDetail });
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();
        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVhnPpc(mrnOrPatientCaseId);
          }
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onAddVrasPpc(mrnOrPatientCaseId);
          }
        } else if (caseDetail.case_products.length > 0) {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
          }
        } else {
          if (hospitalUseCustCaseIDStatus) {
            this._onOpenCustomerCaseModal(caseDetail.id);
          } else {
            this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
          }
        }

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDAdd = async (formData) => {
    try {
      const {
        notify, online, setLoader, tableName, user: { name }
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      if (!Object.keys(formData).length > 0) {
        this._onNextCustomerCaseIDStatus();
        return;
      }

      if (formData.hasOwnProperty('CustCaseID')) {
        caseDetail.CustCaseID = (formData.CustCaseID !== null || formData.CustCaseID !== undefined)
          ? formData.CustCaseID
          : null;
      }

      if (online) {
        setLoader(true);
        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments, RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, ChangeRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          CustCaseID, ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          CustCaseID,
        };

        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));

        subset.selectedSets = newArrayOfObj;
        updateCase(subset).then(async (responseJson) => {
          setLoader(false);
          const { status, message } = responseJson;
          if (status) {
            // Update into local db
            updateCaseByPrimaryId(caseDetail.id, caseDetail);
            this.setState({ caseDetail });

            if (Object.keys(formData).length > 0) {
              if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
                this._onAddVhnPpc(caseDetail.id);
              } else if ((caseDetail.case_products.length > 0
                || caseDetail.case_products.length === 0)
                && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
                this._onAddVrasPpc(caseDetail.id);
              } else if (caseDetail.case_products.length > 0) {
                this._onRedirect(`/manage-case/${caseDetail.id}/products/list`);
              } else {
                this._onRedirect(`/manage-case/${caseDetail.id}/products/add`);
              }
            }
          } else {
            notify({ type: 'error', message });
          }
        });
      } else {
        caseDetail.Sync = 1;
        this._onGoBack();

        // Update into local db
        updateCaseByPrimaryId(caseDetail.id, caseDetail);
        setLoader(false);
        this.setState({ caseDetail });

        if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')) {
          this._onAddVhnPpc(mrnOrPatientCaseId);
        } else if ((caseDetail.case_products.length > 0
          || caseDetail.case_products.length === 0)
          && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')) {
          this._onAddVrasPpc(mrnOrPatientCaseId);
        } else if (caseDetail.case_products.length > 0) {
          this._onRedirect(`/manage-case/${caseDetail.id}/products/list`);
        } else {
          this._onRedirect(`/manage-case/${caseDetail.id}/products/add`);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCustomerCaseIDBack = async () => {
    try {
      const {
        tableName
      } = this.props;
      const { mrnOrPatientCaseId } = this.state;

      const caseDetail = await getTableCaseByCaseId(mrnOrPatientCaseId, tableName);
      let vhnPpcValue = {};

      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }

      if (
        (caseDetail.case_products.length > 0 || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'HIP' && (vhnPpcValue.VHN_PPC === '1' || vhnPpcValue.VHN_Other === '1')
      ) {
        this._onAddVhnPpc(mrnOrPatientCaseId);
      } else if (
        (caseDetail.case_products.length > 0 || caseDetail.case_products.length === 0)
        && caseDetail.CaseType === 'KNEE' && (vhnPpcValue.VRAS_PPC === '1' || vhnPpcValue.VRAS_Other === '1')
      ) {
        this._onAddVrasPpc(mrnOrPatientCaseId);
      } else if (caseDetail.case_products.length > 0) {
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/list`);
      } else {
        // alert(`/manage-case/${mrnOrPatientCaseId}/products/add`);
        this._onRedirect(`/manage-case/${mrnOrPatientCaseId}/products/add`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDayFilter = () => {
    try {
      const {
        setTableName, table, setSelectCaseDate
      } = this.props;
      this._onGoBack();
      browserHistory.push('/manage-cases/day-filter');
      const { selectedDate } = this.state;
      setTableName(table);
      setSelectCaseDate(selectedDate);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onUnselectValue = async (key, index) => {
    try {
      const { caseFilter, setCaseFilter } = this.props;
      const { filterData } = this.state;

      if (filterData[key].length > 1) {
        filterData[key].splice(index, 1);
      } else {
        delete caseFilter[key];
        delete filterData[key];
      }
      setCaseFilter(caseFilter);
      this.setState({ filterData }, () => this.onFilter());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  // _onClickDrgModalYes = () => {
  //   try {
  //     const { caseDetail } = this.state;
  //     this._onGoBack();
  //     browserHistory.push(`/manage-case/${caseDetail.id}/products/dgr`);
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  // _onClickDrnModalNo = () => {
  //   try {
  //     const { caseDetail } = this.state;
  //     if (caseDetail.case_products.length >= 0 && caseDetail.ProductSubmitted === '0') {
  //       this.zeroProductSubmitModal.show();
  //     }
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  _sortTeamName = async () => {
    try {
      const user = await getUser();
      const newName = user.selectedTeam.name.startsWith('TEAM');
      if (newName === false) {
        this.setState({ updatedTeamName: user.selectedTeam.name });
      } else {
        const updatedTeamName = user.selectedTeam.name.replace('TEAM', '');
        this.setState({ updatedTeamName });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGroupByHospital = async () => {
    try {
      const { isGroup } = this.state;
      this.setState({
        isGroup: !isGroup
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  scrollFunction = () => {
    try {
      const {
        hideShowCalendar, screenWidth,
        // isHideTeamName
      } = this.state;
      window.addEventListener('scroll', () => {
        if (window.scrollY > 280 && screenWidth < 800) {
          this.setState({
            hideShowCalendar: !hideShowCalendar,
            // isHideTeamName: !isHideTeamName,
          });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRefreshForCalendar = async () => {
    try {
      this.setState({
        hideShowCalendar: true,
        // isHideTeamName: false,
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShipmentsTruck = (cases) => {
    if (cases.shipFromLoc === 'ALL') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=DEPUY&shipTo=${cases.customer}`);
    } else if (cases.shipFromLoc === 'DEPUY') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=DEPUY&shipTo=${cases.customer}`);
    } else if (cases.shipFromLoc === 'OFFICE') {
      this._onRedirect(`/inventory/shipments?shipFromLoc=OFFICE&shipTo=${cases.customer}`);
    }
  }

  _onShowDgrRequiredModal = (id) => {
    const dgrRequiredOnSubmitCaseModal = new window.bootstrap.Modal(window.$('#dgrRequiredOnSubmitCaseModal-dgr-req-on-submit'));
    this.setState({
      idForDgrRequest: id
    });
    dgrRequiredOnSubmitCaseModal.show();
  }

  _onClickDrgModalYes = () => {
    try {
      const { idForDgrRequest } = this.state;
      const { online, notify } = this.props;
      if (online && idForDgrRequest) {
        document.getElementById(`uploadDGREle-${idForDgrRequest}`).click();
      } else {
        notify({ type: 'error', message: 'DGRs cannot be viewed without an internet connection' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _setShipments = async () => {
    try {
      const shipmentsRes = await getShipments({});
      this.setState({ shipments: shipmentsRes.data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onApplyNewFilter = async (data) => {
    try {
      this.setState({ filterDataNew: data });

      const { setCaseFilter, notify } = this.props;
      const { filterDataNew } = this.state;

      const { filterDataNew: { selectedStartDate, selectedEndDate } } = this.state;
      if (selectedStartDate !== undefined || selectedEndDate !== undefined) {
        if ((selectedStartDate === '' || selectedStartDate === undefined) && (selectedEndDate !== '')) {
          notify({ type: 'error', message: 'Please select start date' });
          return;
        }
      }
      _.mapKeys(filterDataNew, (value, key) => {
        if (_.isArray(value) && _.isEmpty(value)) delete filterDataNew[key];
      });

      _.mapKeys(filterDataNew, (value, key) => {
        if (_.isString(value) && _.isEmpty(value)) delete filterDataNew[key];
      });

      if (this._checkValidation(filterDataNew)) {
        this._onGoBack();
        setCaseFilter(filterDataNew);
        browserHistory.push('/manage-cases/filter-cases');
      } else {
        notify({ type: 'error', message: 'You must select at least one search field' });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _checkValidation = (filterDataNew) => {
    try {
      if (Object.keys(filterDataNew).length) {
        return !!Object.keys(filterDataNew).filter((field) => !!(filterDataNew[field].length || (filterDataNew[field] !== ''))).length;
      } return false;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmitACMPushCase = async () => {
    try {
      const {
        notify,
        online,
        setLoader,
        tableName,
        selectCaseDate
      } = this.props;

      const { caseDetail } = this.state;

      if (online) {
        setLoader(true);
        const responseJson = await listSingleCase(caseDetail.CaseScheduleID);
        const { message, status } = responseJson;
        if (status) {
          const caseDetails = responseJson.data[0];
          caseDetails.id = parseInt(caseDetail.id, 10);
          caseDetails.CaseDate = caseDetail.CaseDate;
          caseDetails.CaseTime = caseDetail.CaseTime;
          // Update the response when update API change
          updateTableWiseCaseByCaseId(caseDetails.RepCaseNo, caseDetails, tableName);
          const getMonthAndYear = moment(caseDetails.CaseDate).format('MM-YY');
          const passMonthAndYear = moment(getMonthAndYear, 'MM-YY');
          await this._getListCases(passMonthAndYear.startOf('month').format('YYYY-MM-DD'),
            passMonthAndYear.endOf('month').format('YYYY-MM-DD'));
          await this._getDateSlot();
          this.onDateClick(selectCaseDate === '' ? new Date() : selectCaseDate);
          this.onFilter();
        } else {
          notify({ type: 'error', message });
        }
      } else {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCase = async (id) => {
    try {
      const {
        notify, online, tableName
      } = this.props;

      if (online) {
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseDetail });

        if (caseDetail.ACM === '0') {
          this.setState({
            acmPushCaseStatusCount: 1
          });
          this._onACMPushCaseStatus();
        } else {
          this._onACMPushCaseConfirm();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onPushCaseYes = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const {
        caseDetail: {
          Age,
          Gender,
          Height,
          HeightUnits,
          PatientID,
          Weight,
          WeightUnits,
          case_xrays,
          MRN,
          Side,
        },
      } = this.state;

      if (online) {
        let xrayCountFlag = 0;
        const xrayStatusFlag = typeof case_xrays !== 'undefined' ? case_xrays.length : 0;
        if (xrayStatusFlag > 0) {
          case_xrays.forEach((element) => {
            if (
              element.Filename.includes('.dcm')
              || element.Filename.includes('.jpeg')
              || element.Filename.includes('.jpg')
            ) {
              xrayCountFlag++;
            }
          });
        }

        if (Number(xrayCountFlag) > 0) {
          const MessageStatusFlag = [];
          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (Side === '' || Side === null) {
            MessageStatusFlag.push(MessageStatusFlag.length > 0 ? '& Side' : 'Side');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmMessageStatusFlag: MessageStatusFlag,
              acmPushCaseStatusCount: 5
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        } else {
          const fieldsToCheck = [
            { field: Age, name: 'Age' },
            { field: Gender, name: 'Gender' },
            { field: Height, name: 'Height' },
            { field: HeightUnits, name: 'Height Units' },
            { field: Side, name: 'Side' },
            { field: Weight, name: 'Weight' },
            { field: WeightUnits, name: 'Weight Units' },
          ];

          const MessageStatusFlag = fieldsToCheck.filter(
            ({ field }) => typeof field === 'undefined' || field === null || field === '' || field === '.00'
          )
            .map(({ name }) => name);

          if ((PatientID === '' || PatientID === null) && (MRN === '' || MRN === null)) {
            MessageStatusFlag.push('Patient or MRN');
          }

          if (MessageStatusFlag.length > 0) {
            this.setState({
              acmPushCaseStatusCount: 2,
              acmMessageStatusFlag: MessageStatusFlag.sort()
            });
            this._onACMPushCaseStatus();
          } else {
            this._updatePushToACM();
          }
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updatePushToACM = async () => {
    try {
      const {
        online,
        notify,
        setLoader,
        user: {
          territories,
          territoryId
        }
      } = this.props;
      const {
        caseDetail: {
          CaseScheduleID
        },
      } = this.state;

      if (online) {
        setLoader(true);
        const pushData = {
          caller: 'OPT'
        };

        territories.map((item) => {
          if (item.id === territoryId) {
            pushData.TerritoryCode = item.abb;
          }
        });

        const acmResponseJson = await updatePushToACM(CaseScheduleID, pushData);
        const { message, status, result } = acmResponseJson;
        setLoader(false);
        if (typeof result !== 'undefined' && result === 'failure') {
        } else {
          if (status) {
            this.setState({
              acmPushCaseStatusCount: 4,
              acmMessageStatusMessage: message
            });
          } else {
            this.setState({
              acmPushCaseStatusCount: 3,
              acmMessageStatusMessage: message
            });
          }

          this._onACMPushCaseStatus();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseStatus = async () => {
    try {
      const {
        online,
        notify,
      } = this.props;
      const { acmPushCaseStatusCount } = this.state;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });

        if (acmPushCaseStatusCount === 4) {
          this._onSubmitACMPushCase();
        }
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPushCaseNo = () => {
    try {
      const {
        online, notify
      } = this.props;
      if (online) {
        this.setState({
          acmPushCaseStatusCount: 0,
          acmMessageStatusFlag: [],
          acmMessageStatusMessage: ''
        });
      } else {
        notify({ type: 'error', message: 'You must have an internet connection. Please check your connection and try again.', time: 2 });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onACMPushCaseStatus = () => {
    try {
      const acmPushCaseStatus = new window.bootstrap.Modal(window.$('#acmPushCaseStatusModal'));
      acmPushCaseStatus.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  _onACMPushCaseConfirm = () => {
    try {
      const acmPushCaseConfirm = new window.bootstrap.Modal(window.$('#acmPushCaseConfirmModal'));
      acmPushCaseConfirm.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        selectCaseDate, caseFilter, calendarFilter, online, goBack, setUpdatedRoute,
        user: { isBigCards }, setCaseDer, setViewDersDetails, setTableName, prevRoute,
        setSelectCaseDate
      } = this.props;

      const refreshOnlyDay = prevRoute.path.includes('/manage-case');
      const user = await getUser();
      if (user.isGroupByHospital) {
        this.setState({
          isGroup: user.isGroupByHospital
        });
      }

      const { casesDetail } = this.state;
      const lastVisitedRoute = await getStoreLastVisitedRoute();
      if (lastVisitedRoute === 'add-case' || lastVisitedRoute === 'filter') {
        this.setState({ lastVisitedRoute });
      }
      await this._getScreenWidth();
      await this._sortTeamName();
      this.scrollFunction();
      if (online) {
        this._setShipments();
        await syncCases();

        const { currentMonth, currentWeek } = this.state;
        this.setState({
          selectedDate: (selectCaseDate === '' ? new Date() : moment(selectCaseDate)._d),
          filterData: caseFilter,
          currentMonth: (selectCaseDate === '' ? currentMonth : moment(selectCaseDate)._d),
          currentWeek: (selectCaseDate === '' ? currentWeek : moment(selectCaseDate)._d),
          isAcm: calendarFilter.isAcm,
          isProduct: calendarFilter.isProduct,
          hideShowCalendar: true,
          // hideShowCalendar: (calendarFilter.hideShowCalendar === undefined
          //   ? true : calendarFilter.hideShowCalendar),
          smallLargeCard: (((lastVisitedRoute === '' || lastVisitedRoute === '/settings') && isBigCards === true) ? false
            : ((lastVisitedRoute === '' || lastVisitedRoute === '/settings') && isBigCards === false) ? true
              : calendarFilter.smallLargeCard),
          casesDetail
        });

        if (!Object.values(goBack).includes('/office')) {
          if (!refreshOnlyDay) {
            await this._getListCases(
              moment(
                selectCaseDate === ''
                  ? new Date()
                  : selectCaseDate
              ).startOf('month').format('YYYY-MM-DD'),
              moment(
                selectCaseDate === ''
                  ? new Date()
                  : selectCaseDate
              ).endOf('month').format('YYYY-MM-DD')
            );
          } else {
            await this._getListCases(moment(selectCaseDate || new Date()).format('YYYY-MM-DD'),
              moment(selectCaseDate || new Date()).format('YYYY-MM-DD'));
          }
        } else {
          await this._getListCases(moment(selectCaseDate || new Date()).format('YYYY-MM-DD'),
            moment(selectCaseDate || new Date()).format('YYYY-MM-DD'));
        }

        await this._getDateSlot();
        const getByCaseId = await getCasesByBetweenDate(
          moment(selectCaseDate || new Date()).format('YYYY-MM-DD'),
          moment(selectCaseDate || new Date()).format('YYYY-MM-DD')
        );
        setSelectCaseDate(moment(selectCaseDate === '' ? new Date() : selectCaseDate)._d);
        this._updateCaseList(getByCaseId);
        this.onFilter();
      } else {
        const { currentMonth, currentWeek } = this.state;
        this.setState({
          selectedDate: (selectCaseDate === '' ? new Date() : moment(selectCaseDate)._d),
          filterData: caseFilter,
          currentMonth: (selectCaseDate === '' ? currentMonth : moment(selectCaseDate)._d),
          currentWeek: (selectCaseDate === '' ? currentWeek : moment(selectCaseDate)._d),
          isAcm: calendarFilter.isAcm,
          isProduct: calendarFilter.isProduct,
          hideShowCalendar: true,
          // hideShowCalendar: (calendarFilter.hideShowCalendar === undefined
          //   ? true : calendarFilter.hideShowCalendar),
          smallLargeCard: calendarFilter.smallLargeCard,
          casesDetail
        });
        await this._getListCases(moment(selectCaseDate === '' ? new Date() : selectCaseDate).startOf('month').format('YYYY-MM-DD'),
          moment(selectCaseDate === '' ? new Date() : selectCaseDate).endOf('month').format('YYYY-MM-DD'));
        await this._getDateSlot();
        setSelectCaseDate(moment(selectCaseDate === '' ? new Date() : selectCaseDate)._d);
        this.onFilter();
      }
      storeLastVisitedRoute('/manage-cases');
      setUpdatedRoute('/manage-cases');
      setTableName('Cases');
      setViewDersDetails(false);
      setCaseDer('');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      selectedDate,
      dateLogs,
      currentMonth,
      hideShowCalendar,
      smallLargeCard,
      isProduct,
      filterData,
      casesList,
      hospitalGroupCasesList,
      caseDetail,
      acmCases,
      screenWidth,
      isGroup,
      currentWeek,
      isHideTeamName,
      updatedTeamName,
      filterDataNew,
      acmPushCaseStatusCount,
      acmMessageStatusFlag,
      acmMessageStatusMessage,
    } = this.state;

    const {
      user: {
        scanner, territories, selectedTeam, territoryId
      }
    } = this.props;
    const dateFormat = 'MMM dd, yyyy';
    return (
      <div className="site-wrapper">
        <section className="sticky-top" style={{ zIndex: '1021' }}>
          <Header
            sideMenu
            goForward={{
              title: 'Add Case <i class="fas fa-plus"></i></a>',
              url: '/manage-case/add-case',
              onGoForward: this._onGoForward,
              showIcon: true
            }}
          />
          {
            !isHideTeamName && (
              <CalenderSearchSection
                table="Cases"
                onToday={this._onToday}
                selectedTeam={updatedTeamName && updatedTeamName}
                // selectedTeam={selectedTeam && selectedTeam.name}
                screenWidth={screenWidth}
                onFilter={(data) => this._onApplyNewFilter(data)}
                previousData={filterDataNew}
              />
            )
          }
        </section>
        <section>
          <div className="container">
            <div className="row">
              {hideShowCalendar
                ? (
                  <Calendar
                    onDateClick={this.onDateClick}
                    nextMonth={() => {
                      this._addMonths();
                    }}
                    prevMonth={() => {
                      this._subMonths();
                    }}
                    selectedDate={selectedDate}
                    dateLogs={dateLogs}
                    currentMonth={currentMonth}
                  />
                ) : (
                  <WeekCalendar
                    onDateClick={this.onDateClick}
                    nextWeek={() => {
                      this._addWeeks();
                    }}
                    prevWeek={() => {
                      this._subWeeks();
                    }}
                    selectedDate={selectedDate}
                    dateLogs={dateLogs}
                    currentMonth={currentWeek}
                  />
                )}
              <div className={`col-md-${hideShowCalendar ? '6' : '12'}`}>
                <section className={`${hideShowCalendar && screenWidth > 800 ? 'sticky-cal-date-filter' : 'stick-icons mb-2'}`}>
                  <div className="section-header">
                    <div className="row gx-0 pt-1">
                      <div className="col-4 align-self-center">
                        <p className="date" style={{ paddingTop: 6 }}>
                          {/* {!hideShowCalendar
                        && (
                          <button
                            className="btn btn-arrow"
                            onClick={this._subDays}
                          >
                            <span>
                              <i className="fas fa-chevron-left" />
                            </span>
                          </button>
                        )} */}
                          {format(selectedDate, dateFormat)}
                          {/* { !hideShowCalendar
                        && (
                          <button
                            className="btn btn-arrow"
                            onClick={this._addDays}
                          >
                            <span>
                              <i className="fas fa-chevron-right" />
                            </span>
                          </button>
                        )} */}
                        </p>
                      </div>
                      <div className="col-8">
                        <div className="d-flex" style={{ alignItems: 'center' }}>
                          <div className="col text-end">
                            <Link
                              onClick={this._onDayFilter} className="link cursor-pointer"
                            >
                              <img width="24px" src={FilterIcon} alt="arrow" />
                            </Link>
                          </div>
                          <div className="col text-end">
                            <button
                              className={isProduct ? 'btn btn-link link btn-link-stop select-acm' : 'btn btn-link link'}
                              style={{ paddingTop: '4px', paddingRight: '5px' }}
                              onClick={this._onProduct}
                            >
                              {
                                isProduct ? <img width="20px" src={ZeroOutLine} alt="arrow" />
                                  : <img width="20px" src={ZeroSelected} alt="arrow" />
                              }
                            </button>
                          </div>
                          <div className="col text-end">
                            <button
                              className={`btn btn-link link ${screenWidth < 800 ? 'mobile-clock-icon' : 'desktop-clock-icon'}`}
                              style={{ paddingRight: '6px' }}
                              onClick={this._onGroupByHospital}
                            >{(!isGroup) ? <img width="24px" src={HospitalBoxIcon} alt="arrow" /> : <img width="24px" src={ClockTimeIcon} alt="arrow" />}
                            </button>
                          </div>
                          {
                            screenWidth < 800
                            && (
                              <div className="col text-end">
                                <button
                                  className="btn btn-link link" style={{ paddingTop: '8%', paddingRight: '1px' }}
                                  onClick={() => {
                                    if (window.scrollY > 0) {
                                      window.scrollTo({ top: 0, behavior: 'instant' });
                                      setTimeout(this._onHideShowCalendar, 0);
                                    } else this._onHideShowCalendar();
                                  }}
                                >
                                  {/* {hideShowCalendar ? 'HIDE CALENDAR' : 'SHOW CALENDAR'} */}
                                  <img width="24px" src={CalenderIcon} alt="arrow" />
                                </button>
                              </div>
                            )
                          }
                          <div className="col text-end">
                            <button
                              className="btn btn-link link pe-0" onClick={this._onSmallLargeCard}
                            >
                              {smallLargeCard ? <img width="24px" src={ArrowExpand} alt="arrow" /> : <img width="24px" src={ArrowCollapse} alt="arrow" />}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* eslint-disable-next-line max-len */}
                    {/*   <div  className={(isAcm === true) ? 'btn btn-link link btn-link-stop select-acm' : 'btn btn-link link'} */}
                    {/*      onClick={this._onACM} */}
                    {/*    >&nbsp;ACM */}
                    {/*    </button> */}
                    {/*  </div> */}

                    <div className="row">
                      <div className="row" style={{ paddingRight: 'inherit' }}>
                        {
                          (
                            filterData && Object.keys(filterData).map((key) => (
                              filterData[key].map((item, index) => (
                                <div key={index} className="col-6 pr-0">
                                  <div className="selection selection-sm">
                                    <p className="text-ellipsis-filter-ops">{item}</p>
                                    <button
                                      className="btn"
                                      onClick={() => this._onUnselectValue(key, index)}
                                    >
                                      <i className="fas fa-times" />
                                    </button>
                                  </div>
                                </div>
                              ))
                            ))
                          )
                        }
                      </div>
                    </div>
                  </div>
                </section>

                <PullToRefresh onRefresh={this._onRefreshForCalendar}>
                  <section
                    className="cards-section pt-0 caseList-device-height"
                    ref={this.topRef}
                  // style={{
                  //   overflowY: hideShowCalendar ? 'hidden' : 'scroll', overflowX: 'hidden'
                  // }}
                  >
                    {
                      isGroup
                        ? (hospitalGroupCasesList.length > 0)
                          ? hospitalGroupCasesList.map((cases, key) => (
                            <div className={key === 0 ? '' : 'pt-2'} key={key}>
                              <div className="d-flex align-items-center pt-2" style={{ height: '38px' }}>
                                <div className="">{cases.customer === 'null' ? '-' : cases.customer}</div>
                                {cases.hasShipments ? (
                                  <>
                                    <div className="case-truck ml-auto">
                                      <span className="cartNo" />
                                      <Link
                                        className="cursor-pointer"
                                        onClick={() => this._onShipmentsTruck(cases)}
                                      >
                                        <img width="25px" src={TruckOutlineIcon} alt="shipments" />
                                      </Link>
                                    </div>
                                    <div className="case-cart">
                                      <span className="cartNo">{cases.qty}</span>
                                      <Link
                                        className="cursor-pointer"
                                        onClick={cases.customer === 'null'
                                          ? () => { }
                                          : () => this._onRedirect(`/manage-case/aggregate-plan/${cases.id}`)}
                                      >
                                        <img width="25px" src={CartOutlineIcon} alt="cart" />
                                      </Link>
                                    </div>
                                  </>
                                ) : (
                                  <div className="case-cart ml-auto">
                                    <span className="cartNo">{cases.qty}</span>
                                    <Link
                                      className="cursor-pointer"
                                      onClick={cases.customer === 'null'
                                        ? () => { }
                                        : () => this._onRedirect(`/manage-case/aggregate-plan/${cases.id}`)}
                                    >
                                      <img width="25px" src={CartOutlineIcon} alt="cart" />
                                    </Link>
                                  </div>
                                )}

                              </div>
                              {
                                cases.data.map((data) => (
                                  <CaseRow
                                    table="Cases"
                                    key={data.id}
                                    keyValue={data.id}
                                    data={data}
                                    smallLargeCard={smallLargeCard}
                                    onFilter={this._onFilter}
                                    onRedirect={this._onRedirect}
                                    onCancel={this._onCancel}
                                    onGetACMCase={this._onGetACMCase}
                                    onSubmitCase={this._onSubmitCase}
                                    onMrnPatientIdAdd={this._onOpenMrnPatientIdModal}
                                    onCaseSubmitted={this._onCaseSubmitted}
                                    scanner={scanner}
                                    onRefreshDate={this.onDateClick}
                                    onShowDgrRequiredModal={this._onShowDgrRequiredModal}
                                    screenWidth={screenWidth}
                                    addVhnPpc={this._onAddVhnPpc}
                                    addVrasPpc={this._onAddVrasPpc}
                                    territories={territories}
                                    selectedTeam={selectedTeam}
                                    territoryId={territoryId}
                                    type="caseCard"
                                    onACMPushCase={this._onACMPushCase}
                                    onCustomerCaseAdd={this._onOpenCustomerCaseModal}
                                  />
                                ))
                              }
                            </div>
                          )) : <div className="text-center mt-5" />
                        : (casesList.length > 0)
                          ? casesList.map((data, key) => (
                            <CaseRow
                              table="Cases"
                              key={key}
                              keyValue={key}
                              data={data}
                              smallLargeCard={smallLargeCard}
                              onFilter={this._onFilter}
                              onRedirect={this._onRedirect}
                              onCancel={this._onCancel}
                              onGetACMCase={this._onGetACMCase}
                              onSubmitCase={this._onSubmitCase}
                              onMrnPatientIdAdd={this._onOpenMrnPatientIdModal}
                              onCaseSubmitted={this._onCaseSubmitted}
                              scanner={scanner}
                              onRefreshDate={this.onDateClick}
                              onShowDgrRequiredModal={this._onShowDgrRequiredModal}
                              screenWidth={screenWidth}
                              isGroup={isGroup}
                              addVhnPpc={this._onAddVhnPpc}
                              addVrasPpc={this._onAddVrasPpc}
                              territories={territories}
                              selectedTeam={selectedTeam}
                              type="caseCard"
                              onACMPushCase={this._onACMPushCase}
                              onCustomerCaseAdd={this._onOpenCustomerCaseModal}
                            />
                          )) : <div className="text-center mt-5" />
                    }
                    {/* <DgrRequiredOnSubmitCase */}
                    {/*  onClickYes={this._onClickDrgModalYes} */}
                    {/* /> */}
                  </section>
                </PullToRefresh>
                <DgrRequiredOnSubmitCase
                  onClickYes={this._onClickDrgModalYes}
                  id="dgr-req-on-submit"
                />
                <MrnOrPatientIdModal onSubmit={this._onMrnPatientIdAdd} />
                <ZeroProductSubmitModal
                  onSubmitProductCaseYes={this._onSubmitProductCaseYes}
                  onSubmitProductCaseNo={this._onSubmitProductCaseNo}
                  caseDetail={caseDetail}
                />
                <RequiredMrnOrPatientId onClickOk={this._onAddPatientIdOrMrn} />
                <AlreadySubmittedCase />
                <CancelCaseModal
                  onCancelCase={this._onCaseCancel}
                  onCaseRowAcmCase={acmCases}
                  onCancelCaseBack={this._onCancelCaseBack}
                />
                <VhnPpcModal
                  onClickNo={this._onClickVhnPpcNo}
                  onClickYes={this._onClickVhnPpcYes}
                />
                <VrasPpcModal
                  onClickNo={this._onClickVrasPpcNo}
                  onClickYes={this._onClickVrasPpcYes}
                />
                <AcmPushCaseConfirmModal
                  onPushCaseYes={this._onPushCaseYes}
                  onPushCaseNo={this._onPushCaseNo}
                />
                <AcmPushCaseStatusModal
                  messageStatus={acmPushCaseStatusCount}
                  onPushCaseStatus={this._onPushCaseStatus}
                  acmMessageStatusFlag={acmMessageStatusFlag}
                  acmMessageStatusMessage={acmMessageStatusMessage}
                />
                <CustCaseIDModal
                  onSubmit={this._onCustomerCaseIDAdd}
                  onBack={this._onCustomerCaseIDBack}
                />
                <RequiredCustCaseID onClickOk={this._onCustomerCaseIDStatus} />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withVhnPpcOtherCharge(
  withCaseFilter(
    withUser(
      withTableName(
        withSetsListStateStorage(
          withCalendarFilter(
            withSelectedSetsPayload(
              withOnline(
                withGoBack(
                  withTeam(
                    withSelectCaseDate(
                      withNotify(
                        withLoader(
                          withUpdatedRoute(
                            withCaseDer(
                              withViewDersDetails(
                                withAggregatePlan(
                                  withPrevRoute(
                                    withSalesYTD(
                                      withCalendarMonthEndDate(
                                        ManageCases
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
